// extracted by mini-css-extract-plugin
export var deviceTooltipTrigger = "DiscountSwitch-module--deviceTooltipTrigger--b8b4f";
export var rowReverse = "DiscountSwitch-module--rowReverse--691f0";
export var switchRoot = "DiscountSwitch-module--switchRoot--921a1";
export var switchThumb = "DiscountSwitch-module--switchThumb--b3886";
export var switchWrapper = "DiscountSwitch-module--switchWrapper--3954c";